import {TabBody} from "../../../tab-content";
import {ManagedTab} from "../../../managed-tabs";
import "./OperationalOverviewTab.scss";
import {useOperationalEntity} from "../../context";
import {OperationalDetailsColumn} from "./OperationalDetailsColumn";
import {OperationalDetailsColumnV2} from "./v2/OperationalDetailsColumnV2";
import {useRecentlyViewedOperationalEntities} from "../../../hooks";
import {useEffect} from "react";
import {OperationalBoidsColumn} from "../../boids";
import {HistoryTabColumn} from "../../history";
import {useFlags} from "launchdarkly-react-client-sdk";
import {features} from "../../../features";

export const OperationalOverviewTab: ManagedTab = () => {
  const {
    entity: {id}
  } = useOperationalEntity();
  const {addBrowsedOperationalEntity} = useRecentlyViewedOperationalEntities();
  const flags = useFlags();
  useEffect(() => addBrowsedOperationalEntity(id), [id]);

  const DetailsColumn = flags[features.pdt.entities.developerEntitySelfService]
    ? OperationalDetailsColumnV2
    : OperationalDetailsColumn;

  return (
    <TabBody className={"operational-overview-tab-body"} name={"overview"}>
      <DetailsColumn />
      <OperationalBoidsColumn />
      <HistoryTabColumn id={id} />
    </TabBody>
  );
};
